<template>
  <div class="app">
    <SiteHeader theme="dynamic" />
    <NuxtPage />
  </div>
</template>

<script setup lang="ts">
import { type SeoMetaTagType, toHead } from 'vue-datocms';
import type { GetGeneralQuery, GeneralFragment } from '#gql';
import SiteHeader from '~/components/site-header/SiteHeader.vue';
import { buildStructuredDataJsonLd } from '~/utils/structured-data';

const { data } = useAsyncGql({
  operation: 'GetGeneral'
});

const general = computed(() => {
  return ((data.value as GetGeneralQuery | null | undefined)?.general ??
    null) as GeneralFragment | null;
});
provide('general', general);

const { data: siteData } = await useAsyncGql({
  operation: 'GetSiteData'
});

// @ts-ignore
useHead(toHead(siteData.value._site.faviconMetaTags));

const { data: structuredData } = await useAsyncGql({
  operation: 'StructuredDataModel'
});

const structuredDataModel = (
  structuredData.value as
    | { structuredDataModel?: Record<string, unknown> }
    | null
    | undefined
)?.structuredDataModel;
const structuredDataJsonLd = buildStructuredDataJsonLd(structuredDataModel);

const route = useRoute();
const runtimeConfig = useRuntimeConfig();
const canonical = computed(() => {
  const base = (runtimeConfig.public.baseUrl || '').replace(/\/$/, '');
  const path = route.path === '/' ? '/' : route.path.replace(/\/+$/, '');
  return `${base}${path}`;
});

useHead(() => ({
  link: canonical.value
    ? [
        {
          rel: 'canonical',
          href: canonical.value,
          key: 'canonical'
        }
      ]
    : [],
  script: structuredDataJsonLd
    ? [
        {
          type: 'application/ld+json',
          key: 'cms-structured-data',
          innerHTML: JSON.stringify(structuredDataJsonLd)
        }
      ]
    : []
}));
</script>
